import { Observable } from 'rxjs';
import { Location } from '@core/data/location/location.model';

export abstract class LocationRepository {
  /**
   * Lists locations for a site.
   *
   * Success:
   * - Emits a `Location[]` containing all locations for `siteId`.
   *
   * Empty:
   * - Emits `[]` when the site exists but has no locations, or when no fixtures are mapped for the site.
   *
   * Error:
   * - Emits a domain error only for transport/authz/server failures.
   * - Absence of locations MUST NOT be represented as an error.
   */
  abstract listBySite(siteId: number): Observable<Location[]>;

  /**
   * Gets one location by `siteId` and `locationId`.
   *
   * Success:
   * - Emits a `Location` when a matching location exists for the provided site.
   *
   * Empty:
   * - Emits `null` when no matching location exists in an otherwise successful response path.
   *
   * Error:
   * - Emits a domain error (for example auth/forbidden/not-found/server) only when the
   *   backend explicitly signals a failure condition.
   * - Use `null` for normal "not present in successful lookup" semantics; use a domain
   *   error for explicit backend failures.
   */
  abstract getById(siteId: number, locationId: number): Observable<Location | null>;
}
